import { Box } from "@mui/material";
import React, { useState } from "react";

import { useUserProfile } from "api/services/useUserProfile";
import { useShouldSeeDetectorDataOnboarding } from "hooks/useShouldSeeDetectorDataOnboarding/useShouldSeeDetectorDataOnboarding";
import { GuidanceModal } from "new-components/modals/GuidanceModal";

import imageSrc from "../assets/image.png";


export function DataPageOnboarding() {
  const { updateUserProfile } = useUserProfile();
  const shouldSeeDetectorDataOnboarding = useShouldSeeDetectorDataOnboarding();
  const [dismissed, setDismissed] = useState(false);
  const open = shouldSeeDetectorDataOnboarding && !dismissed;

  const handleConfirmation = () => {
    setDismissed(true);
    updateUserProfile({
      data_onboarded: true,
    });
  };

  return (
    <GuidanceModal
      title="Detector Data"
      subtitle="The Data page lets you see a list of all of the image queries your detector has received."
      open={open}
      onClose={handleConfirmation}
      onConfirmation={handleConfirmation}
      steps={[
        <>
          <span className="font-bold">Choose detector</span> to show data from dropdown.
        </>,
        "Want to customize what’s shown? Show and hide columns here.",
        "Thumbnail and timestamp for each query.",
        "Details about answers and sources of answers. (The “Best answer” column tends to be the most useful place to start for new users.)",
      ]}
      image={<Box component="img" src={imageSrc} className="w-[350px]" />}
    />
  );
}
